import { updateQueryStringParameter, getHashQuery } from '@/utils/index';
import { getQX } from '@/views/detailPage/utils/qsid';

export function isSupportStockLink() {
  return getQX('stockLink');
}

export function genLinkNewWebview(url) {
  const { href, hash } = window.location;
  const targetUrl = `${href.replace(hash, '')  }#${  updateQueryStringParameter(url, 'accessKey', getHashQuery('accessKey'))}`;
  const newUrl = `client.html?action=ymtz^webid=2804^fontzoom=no^url=${targetUrl}`;
  return newUrl;
}

export function openNewWebview(url) {
  window.location.href = genLinkNewWebview(url);
}

export function genLinkStockMarket(code, marketid) {
  return `client.html?action=ymtz^stockcode=${code}^webid=2205^marketid=${marketid}`;
}

export function openStockMarket(code, marketid) {
  window.location.href = genLinkStockMarket(code, marketid);
}

export function genLinkStock(code, name, market) {
  return `client.html?action=ymtz^webid=2205^stockcode=${code}^stockname=${name}^marketid=${market}`;
}

export function openStock(code, name, market) {
  window.location.href = genLinkStock(code, name, market);
}

export function openThirdLink(link) {
  const url = `client.html?action=ymtz^webid=2804^fontzoom=no^url=${link}`;
  window.location.href = url;
}

export default {
  install(Vue) {
    Vue.prototype.$native = {
      genLinkNewWebview,
      genLinkStockMarket,
      genLinkStock,
      openNewWebview,
      openStockMarket,
      openStock,
      openThirdLink,
    };
  },
};
